module.exports = __webpack_public_path__ + "img/icon_map.cd64fe97.png";